import React from 'react';

export default class ErrorBoundaryWidgetContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { widgetComponentName } = this.props;

    // Print error to console until we find another alternative of logging errors
    // eslint-disable-next-line no-console
    console.error('Widget rendering error', { error, errorInfo, widgetComponentName });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <div />;
    }

    return children;
  }
}
